module.exports = __webpack_public_path__ + "img/triangle_arrow_gray_up.321e8999.svg";